"use client"

import dynamic from "next/dynamic"

const CheckoutClient = dynamic(() => import("./client"), { ssr: false, loading: () => null })

export default function CheckoutClientWrapper() {
  return <CheckoutClient />
}
